import React, { useState } from 'react';
import CustomButton from './custom-button/custom-btn.component';
import { fetchService } from '../api/common';
import fileDownload from 'js-file-download';
import MainLoaderModal from './modal/main-loader/main-loader.component';

export default function ExportReportButton({
  title = 'Export Report',
  fileName = 'report.xlsx',
  apiUrl,
  description = 'Exporting report, please wait...',
}) {
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  const exportReports = async () => {
    setIsOpen(true);
    setIsLoading(true);
    setErrorMessage(null);
    const response = await fetchService(apiUrl);

    if (response.success) {
      fileDownload(response.data.data, fileName);
      setIsLoading(false);
      setIsOpen(false);
      return;
    }

    setErrorMessage(response.message || 'Failed to export reports.');
    setIsLoading(false);
  };

  return (
    <>
      <MainLoaderModal
        openModal={isOpen}
        description={description}
        errorMessage={errorMessage}
        tryAgainAction={exportReports}
        cancelAction={() => setIsOpen(false)}
      />

      <CustomButton
        classes="primary"
        isLoading={isLoading}
        onClick={exportReports}
      >
        {title}
      </CustomButton>
    </>
  );
}
